import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { Form, Input, Button, Card, List, Typography } from "antd";
import { toast } from "react-toastify";

export default function AddOrganisations() {
    const { backUrl, authData } = useContext(AuthContext);
    const { Title } = Typography;

    const [organisations, setOrganisations] = useState([]);
    const [newOrg, setNewOrg] = useState({
        name: ""
    });
    const [loading, setLoading] = useState(false);

    // ✅ Fetch Organisations
    const fetchOrganisations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`);
            setOrganisations(res.data.results);
        } catch (err) {
            console.error("Error fetching organisations", err);
        }
    };

    // ✅ Add Organisation
    const handleAddOrganisation = async () => {
        if (!newOrg.name) {
            toast.error("Organisation name is required");
            return;
        }

        try {
            setLoading(true);

            await axios.post(
                `${backUrl}/api/emp/organisations/`,
                newOrg,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            toast.success("Organisation added successfully!");

            // Reset input
            setNewOrg({ name: "" });

            // Refresh list
            fetchOrganisations();
        } catch (err) {
            console.error("Error adding organisation", err);
            toast.error("Failed to add organisation");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrganisations();
    }, []);

    return (
        <center>
            <div style={{ padding: "20px", width: '600px' }}>
                <Title level={4}>Add Organisations</Title>

                {/* 🔹 Add Organisation */}
                <Card style={{ marginBottom: "20px" }}>
                    <Form layout="vertical">
                        <Form.Item label="Organisation Name">
                            <Input
                                placeholder="Enter organisation name"
                                value={newOrg.name}
                                onChange={(e) =>
                                    setNewOrg({ name: e.target.value })
                                }
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            onClick={handleAddOrganisation}
                            loading={loading}
                            block
                            style={{ backgroundColor: '#0e497b', color: 'white' }}
                        >
                            Add Organisation
                        </Button>
                    </Form>
                </Card>

                {/* 🔹 List Organisations */}
                {/* <Card title="Organisations List">
                <List
                    bordered
                    dataSource={organisations}
                    renderItem={(item) => (
                        <List.Item>
                            {item.name}
                        </List.Item>
                    )}
                    locale={{ emptyText: "No organisations found" }}
                />
            </Card> */}
            </div>
        </center>

    );
}